export const parseCode = (code: number | string ): number | undefined => {
    if (typeof code === 'string') {
      const parsed = parseInt(code);
      return !isNaN(parsed) ? parsed : undefined;
    } else if (typeof code === 'number') {
      return code;
    } else {
      return undefined;
    }
  };